import { QuoteVersionCreateButton } from "./quote-version.create.button";
import { QuoteVersionCreateForm } from "./quote-version.create.form";

export const QuoteVersionCreate = {
    Button: QuoteVersionCreateButton,
    Component: QuoteVersionCreateForm,
}
